import type { DirectoryPublic } from '@repo/types/directory';
import type { FilePublic } from '@repo/types/files';

/**
 * Type guard to determine if the given entity is a FilePublic object.
 *
 * @param item - The entity to check, which may be a directory or file.
 * @returns True if the entity is a file, false otherwise.
 */
export function getIsFSEntityFile(item?: DirectoryPublic | FilePublic): item is FilePublic {
  if (!item) {
    return false;
  }
  return 'fileType' in item;
}
